@if (hasIssues()) {
  <button
    [class]="badgeClasses()"
    [pTooltip]="detailedTooltipText()"
    tooltipPosition="top"
    (click)="handleClick()">
    @if (errorCount() > 0) {
      <i class="pi pi-exclamation-triangle text-xs"></i>
    } @else if (warningCount() > 0) {
      <i class="pi pi-info-circle text-xs"></i>
    }
  </button>
}
